import { useCallback } from 'react';
import { useTranslation } from '../../../i18n/LanguageContext';
import { daysUntil } from '../../../utils/assignmentDeadlines';

/**
 * Texts of Eğitim Raporları (`educationReports.*`). Roles and document names
 * are stored values and stay as they are; the Excel file stays Turkish.
 */
const useEducationReportText = () => {
  const { t, language, locale } = useTranslation();
  const label = useCallback((key, vars) => t(`educationReports.${key}`, vars), [t]);
  const statusLabel = useCallback((status) => t(`educationReports.status.${status}`), [t]);
  const typeLabel = useCallback((type) => (type === 'SOP' ? t('educationReports.types.sop') : t('educationReports.types.training')), [t]);
  /** "3 gün kaldı" / "2 gün gecikti" / "" for an assignment's due date. */
  const deadlineLabel = useCallback((dueDate) => {
    const days = daysUntil(dueDate);
    if (days === null) return '';
    if (days < 0) return t('educationReports.deadline.late', { days: Math.abs(days) });
    if (days === 0) return t('educationReports.deadline.today');
    return t('educationReports.deadline.left', { days });
  }, [t]);
  return { t, language, locale, label, statusLabel, typeLabel, deadlineLabel };
};

export default useEducationReportText;
